<script setup lang="ts">
import type { TaskList } from '~/types/taskList.type'

defineProps({
  taskList: {
    type: Object as PropType<TaskList<undefined>>,
    required: true,
  },
})

defineEmits<{
  close: [boolean]
}>()
</script>

<template>
  <ConfirmModal confirm-text="Abschließen" @close="$emit('close', $event)">
    <slot />
    <template #body>
      <div>
        Bist du dir sicher, dass du die Aufgabenliste <span class="font-semibold">{{ taskList.name }}</span> abschließen möchtest?
      </div>
    </template>
  </ConfirmModal>
</template>
